module.exports = __webpack_public_path__ + "static/media/rate-5.a9f025b2.svg";